<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Form Requisition" subTitle="Forms" />

    <CreateRequisition />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import CreateRequisition from "@/components/Pages/Management/Requisition/CreateForm.vue";

export default defineComponent({
  name: "CreateRequisitionPage",
  components: {
    PageTitle,
    CreateRequisition,
  },
});
</script>
